import moment from "moment";
import React from "react";
import config from "src/config";
import DmonkLogo from 'src/assets/storageIcons/dmonk.png';
import { getLastSession } from "src/services/auth.service";
import { Stack } from "@mui/material";

class TrustInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            last_session: null,
            storage_location: null
        }
    }

    componentDidMount() {
        this.setDetails();
    }

    setDetails = async () => {
        let last_session = await getLastSession();
        if (last_session && !last_session.error && last_session.success) {
            this.setState({
                last_session: last_session.last_session,
                storage_location: last_session.storage_location
            });
        }
    }



    render() {
        return (
            <div style={{ justifyContent: 'center', textAlign: 'center', width: '100%' }}>
                <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" style={{ marginTop: '10px' }}>
                    <div>
                        <img src={DmonkLogo} style={{ height: '18px', width: 'auto', opacity: 0.3 }} />
                    </div>
                    <div>
                        <Stack direction="column" spacing={1}>
                            <p style={{ fontSize: '12px', color: 'lightgray', margin: 0 }}>
                                Files securely stored at {' '}
                                {this.state.storage_location?.city ? this.state.storage_location.city : ''}
                                {this.state.storage_location?.region_name ? `, ${this.state.storage_location.region_name}` : ''}
                                {this.state.storage_location?.country_name ? `, ${this.state.storage_location.country_name}` : ''}
                            </p>
                            <p style={{ fontSize: '12px', color: 'lightgray', margin: 0 }}>
                                Last Login at {' '}
                                {this.state.last_session?.created_at ? moment(this.state.last_session.created_at).format(config.DATETIMEOPTIONS.DATE_TIME_FORMAT) : 'N/A'}
                                {this.state.last_session?.ip_details?.city ? ` from ${this.state.last_session.ip_details.city}` : ''}
                                {this.state.last_session?.ip_details?.country_name ? `, ${this.state.last_session.ip_details.country_name}` : ''}
                            </p>
                        </Stack>
                    </div>
                </Stack>
            </div>
        );
    }
};

export default TrustInfo;
